export const trafficFineConstants = {
  POLICE_STATION_LIST_REQUEST: "POLICE_STATION_LIST_REQUEST",
  POLICE_STATION_LIST_COMPLETE: "POLICE_STATION_LIST_COMPLETE",
  POLICE_STATION_LIST_ERROR: "POLICE_STATION_LIST_ERROR",

  FINES_LIST_REQUEST: "FINES_LIST_REQUEST",
  FINES_LIST_COMPLETE: "FINES_LIST_COMPLETE",
  FINES_LIST_ERROR: "FINES_LIST_ERROR",

  TRAFFIC_FINE_PAYABLE_LIST_REQUEST: "TRAFFIC_FINE_PAYABLE_LIST_REQUEST",
  TRAFFIC_FINE_PAYABLE_LIST_COMPLETE: "TRAFFIC_FINE_PAYABLE_LIST_COMPLETE",
  TRAFFIC_FINE_PAYABLE_LIST_ERROR: "TRAFFIC_FINE_PAYABLE_LIST_ERROR",

  TRAFFIC_FINE_SET_PAYABLE_ACCOUNTS: "TRAFFIC_FINE_SET_PAYABLE_ACCOUNTS",
  TRAFFIC_FINE_SET_PAYABE_CARDS: "TRAFFIC_FINE_SET_PAYABE_CARDS",

  TRAFFIC_FINE_VALIDATE_AMOUNT_REQUEST: "TRAFFIC_FINE_VALIDATE_AMOUNT_REQUEST",
  TRAFFIC_FINE_VALIDATE_AMOUNT_COMPLETE:
    "TRAFFIC_FINE_VALIDATE_AMOUNT_COMPLETE",
  TRAFFIC_FINE_VALIDATE_AMOUNT_ERROR: "TRAFFIC_FINE_VALIDATE_AMOUNT_ERROR",

  TRAFFIC_FINE_CLEAR_FINE_FORM_DATA: "TRAFFIC_FINE_CLEAR_FINE_FORM_DATA",

  TRAFFIC_FINE_CLEAR_VALIDATION_AMOUNT_DATA:
    "TRAFFIC_FINE_CLEAR_VALIDATION_AMOUNT_DATA",

  TRAFFIC_FINE_CLEAR_PAY_BILL_DATA: "TRAFFIC_FINE_CLEAR_PAY_BILL_DATA",

  TRAFFIC_FINE_PAYBILL_REQUEST: "TRAFFIC_FINE_PAYBILL_REQUEST",
  TRAFFIC_FINE_PAYBILL_COMPLETE: "TRAFFIC_FINE_PAYBILL_COMPLETE",
  TRAFFIC_FINE_PAYBILL_ERROR: "TRAFFIC_FINE_PAYBILL_ERROR",

  TRAFFIC_FINE_SELECTED_POLICE_STATION: "TRAFFIC_FINE_SELECTED_POLICE_STATION",

  TRAFFIC_FINE_OTP_CONFIRM_REQUEST: "TRAFFIC_FINE_OTP_CONFIRM_REQUEST",
  TRAFFIC_FINE_OTP_CONFIRM_COMPLETE: "TRAFFIC_FINE_OTP_CONFIRM_COMPLETE",
  TRAFFIC_FINE_OTP_CONFIRM_ERROR: "TRAFFIC_FINE_OTP_CONFIRM_ERROR",

  TRAFFIC_FINE_OTP_RESEND_REQUEST: "TRAFFIC_FINE_OTP_RESEND_REQUEST",
  TRAFFIC_FINE_OTP_RESEND_COMPLETE: "TRAFFIC_FINE_OTP_RESEND_COMPLETE",
  TRAFFIC_FINE_OTP_RESEND_ERROR: "TRAFFIC_FINE_OTP_RESEND_ERROR",
};
